import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateService, UpdateState } from '../../_services/update.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'update-status',
  templateUrl: './update-status.component.html'
})
export class UpdateStatusComponent {
  state$: Observable<UpdateState> = this.updates.state$;

  constructor(private updates: UpdateService, private translateService: TranslateService) {}

  check() { this.updates.checkNow(); }
  apply() { this.updates.applyUpdateAndReloadAllTabs(); }

  getState(state: string): string {
    if(state === 'checking') return this.translateService.instant('updates.checking_for_updates');
    if(state === 'no-update') return this.translateService.instant('updates.up_to_date');
    if(state === 'ready') return this.translateService.instant('updates.update_available');
    if(state === 'downloading') return this.translateService.instant('updates.update_available');
    if(state === 'failed') return this.translateService.instant('updates.update_failed');
    return this.translateService.instant('updates.requires_manual_check');
  }
}
